<template>
  <div id="page-wrapper">
    <v-app-bar
      id="topbar-post-login"
      color="transparent"
      dark
      dense
      fixed
      prominent
    >
      <div class="mt-7">
        <span>SECRETARIA DE EDUCAÇÃO E ESPORTES</span>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-title class="d-flex">
        <div class="logo-container">
          <img
            class="app-icon"
            src="https://cdn.educacao.pe.gov.br/storage/assets/logo_SEE_psh_G02_B_png_779d0caae9.png"
            alt="brasão-home-64px"
          />
        </div>
      </v-toolbar-title>
    </v-app-bar>

    <div id="background-image-wrapper" class="pt-15">
      <v-container class="fill-height d-flex align-center justify-center">
        <vue-aos animation-class="animate__zoomInLeft animate__animated">
          <v-row justify="center" align="center" style="height: 80vh">
            <v-col cols="12" md="6" lg="4">
              <v-card
                elevation="10"
                class="pa-10 rounded-lg"
                color="rgba(255, 255, 255, 0.9)"
              >
                <v-form ref="form" v-model="valid" @submit.prevent="recuperarSenha">
                  <v-row>
                    <v-col class="text-center">
                      <img src="/img/siglasigfoco.svg" alt="brasão-home-64px" />
                      <h1 class="subtitle-1 blue--text text--darken-4 mt-4 font-weight-bold">
                        Recuperar Senha
                      </h1>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="user.senha"
                        solo
                        outlined
                        dense
                        :rules="[
                          (v) => $required(v, 'Senha é obrigatória'),
                          (v) => $min(v, 8, 'A senha deve conter pelo menos 8 caracteres.'),
                          (v) => $max(v, 256, 'A senha deve conter no máximo 256 caracteres..'),
                        ]"
                        placeholder="Nova Senha*"
                        class="rounded-lg ignore-tab"
                        :type="exibirSenha ? 'text' : 'password'"
                        prepend-inner-icon="mdi-lock"
                        append-icon="mdi-eye"
                        @click:append="exibirSenha = !exibirSenha"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="mb-4">
                    <v-col>
                      <v-text-field
                        v-model="user.confirmarSenha"
                        solo
                        outlined
                        dense
                        :rules="[
                          (v) => $required(v, 'Confirmação de senha é obrigatória'),
                          (v) => $min(v, 8, 'Confirmação de senha deve conter pelo menos 8 caracteres.'),
                          (v) => $max(v, 256, 'Confirmação de senha deve conter no máximo 256 caracteres.'),
                          (v) => v === user.senha || 'As senhas informadas não correspondem.'
                        ]"
                        :type="exibirConfirmarSenha ? 'text' : 'password'"
                        placeholder="Confirme a Nova Senha*"
                        class="rounded-lg"
                        prepend-inner-icon="mdi-lock"
                        append-icon="mdi-eye"
                        @click:append="exibirConfirmarSenha = !exibirConfirmarSenha"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="d-flex justify-center">
                    <v-btn
                        color="primary"
                        class="py-4 px-6 mr-3 rounded-lg"
                        type="submit"
                    >
                      Salvar
                    </v-btn>
                    <v-btn outlined @click="acessarSistema()" class="py-4 px-6 mr-3 rounded-lg">
                      Fechar
                    </v-btn>
                  </v-row>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </vue-aos>
        <v-dialog persistent v-model="visible" width="50%">
          <v-card class="not-margin pt-0 pr-0 pl-0">
            <v-toolbar dark color="primary">
              <div class="text-center">Confirmação de Alteração de Senha</div>
            </v-toolbar>
            <div class="container dialog mt-7">
              <v-row class="text-center">
                <p>Senha Recuperada com sucesso!</p>
              </v-row>
              <v-row>
                <p>Acesse o sistema de Gestão de Formação Continuada com as credenciais cadastradas.</p>
              </v-row>
            </div>
            <div class="text-center mt-5">
              <v-btn color="primary" class="ml-2" @click="acessarSistema()">Acessar o Sistema</v-btn>
              <v-btn outlined class="ml-2" @click="toggleModal(false)">Voltar</v-btn>
            </div>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>
    
<script>
import VueAos from "vue-aos";
import PageLoadingMixin from "~/mixins/page-loading.mixin";
import AcessoService from "~/services/acesso.service";

export default {
  name: "TrocarSenha",
  mixins: [PageLoadingMixin, AcessoService],
  components: { VueAos },
  data: () => ({
    user: {
      senha: undefined,
      confirmarSenha: undefined,
    },
    valid: false,
    loading: false,
		visible: false,
    exibirSenha: false,
    exibirConfirmarSenha: false,
  }),
  methods: {
    recuperarSenha() {
      const save = () => {
        const payload = {
          cpf: this.cpf,
          token: this.token,
          senha: this.user.senha,
          confirmarSenha: this.user.confirmarSenha,
        }
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          return this.$mudarSenhaPorRecuperacao(payload)
            .then(() => {
              return this.notificarSucesso();
            });
        });
      };

      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    notificarSucesso() {
      return this.$swal({
        title: 'Senha alterada com sucesso!',
        text: "Acesse o Sistema de Gestão da Formação Continuada – SIGFOCO com as credenciais cadastradas",
        type: "success",
        confirmButtonText: "Acessar Sistema",
        showCancelButton: false
      }).then(() => {
        this.$router.push('/login')
      })
    },
		acessarSistema() {
			this.$router.push({ path: "/login" });
		},
		toggleModal(visible) {
			this.visible = visible;
		}
  },
  computed: {
    cpf() {
      return this.$route.params.cpf;
    },
    token() {
      return this.$route.params.token;
    }
  }
};
</script>
